import { SectionItem } from '@features/shift-post-v2/components'
import { Flex } from '@pinchenterprisesnpm/friday-ui'
import { SHIFT_TRAINING_SHIFTS_TOOLTIP } from '@src/config/TooltipContent/TooltipContent'
import { FormSwitchContainer } from '@src/features/shift-post-v2/steps/shift-details-step/components/additional-options-section/additional-options-section.styles'
import { FormSwitch } from '@src/components/common/FormComponents'
import { fullEditUpshiftersAndModeTestIds } from '@src/components/business/Shift/FullEdit/UpshiftersAndMode/utils'
import AuthService from '@src/helpers/authService'
import { connect } from 'formik'
import { ShiftPostPage } from '@src/features/shift-post-v2/pages'
import { IAdditionalOptionsSectionProps } from './additional-options-section.types'

export const AdditionalOptionsSection = connect<IAdditionalOptionsSectionProps>(
  ({ formik, sourcePage }) => {
    const { values, setFieldValue } = formik

    const businessEntity = AuthService.getBusinessEntity()
    const isMandatoryMinAge = (businessEntity?.min_age ?? 0) >= 21
    const isTrainingModeAllowed = businessEntity?.training_mode
    const shouldAlcoholServiceButtonShow = AuthService.getIndustryDetails()!
      .must_be_min_age

    /**
     * Field editing is disabled if template is not selected.
     */
    const editingDisabled =
      sourcePage === ShiftPostPage.POST_SHIFT && !values.template_id

    return (
      <SectionItem title="Additional Options" hasEdit={false}>
        <Flex direction="column">
          {isTrainingModeAllowed ? (
            <FormSwitchContainer>
              <FormSwitch
                label="Is this a Training Shift"
                leftLabel="No"
                rightLabel="Yes"
                name="training_mode"
                value={values.training_mode ?? false}
                handleChange={setFieldValue}
                fieldColumns={10}
                labelTooltipMessage={SHIFT_TRAINING_SHIFTS_TOOLTIP}
                isDisabled={editingDisabled}
              />
            </FormSwitchContainer>
          ) : null}

          {shouldAlcoholServiceButtonShow ? (
            <FormSwitchContainer>
              <FormSwitch
                label="Is alcohol service required"
                name="min_age"
                labelTooltipMessage={
                  isMandatoryMinAge
                    ? 'Please contact Upshift support if you need to turn this setting off for this shift.'
                    : 'This shift requires the employee to be 21 or older.'
                }
                isDisabled={isMandatoryMinAge || editingDisabled}
                value={values.min_age >= 21 ? true : false}
                handleChange={(field: string, value: any) => {
                  if (value) {
                    setFieldValue(field, 21)
                  } else {
                    setFieldValue(field, 0)
                  }
                }}
                leftLabel="No"
                rightLabel="Yes"
                testId={fullEditUpshiftersAndModeTestIds.MUST_BE_21_SWITCH}
              />
            </FormSwitchContainer>
          ) : null}
        </Flex>
      </SectionItem>
    )
  },
)
